import { render } from "./ToWhomList.vue?vue&type=template&id=c6cb7424"
import script from "./ToWhomList.vue?vue&type=script&lang=js"
export * from "./ToWhomList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__